<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>edit</mat-icon></div>
    <div>
      <span>Rectificar ticket</span>
      <small class="dlg-hdr__sub" *ngIf="ticket?.ticketNumber">{{ ticket.ticketNumber }}</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">
  <div class="rectify-info">
    <mat-icon>info</mat-icon>
    <div class="rectify-info__text">
      Se creará una copia rectificativa de <strong>{{ ticket?.ticketNumber || 'este ticket' }}</strong>
      con importe negativo. Esta acción no se puede deshacer.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <ng-container *ngIf="ready">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </ng-container>
  <button mat-stroked-button (click)="closeDialog()" [disabled]="ready">Cancelar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="rectification()" [disabled]="ready">
    <mat-icon>edit</mat-icon> Rectificar
  </button>
</mat-dialog-actions>
